import { extractApiErrorMessage } from '../../../../utils/extractApiErrorMessage';
export const getErrorMessage = (error: unknown, fallback: string): string => extractApiErrorMessage(error) ?? fallback;
